export const http = {
    toJSON: function (data) {
        return ko.toJSON(data);
    },

    get: function (url, query, headers) {
        var promise = $.ajax(url, { data: query, headers: ko.toJS(headers) });
        promise.always(function () {
            console.log('[GET] ' + url, { url: url, query: query, headers: headers, args: arguments });
        });
        return promise;
    },

    put: function (url, data, headers) {
        var promise = $.ajax({
            url: url,
            data: this.toJSON(data),
            type: 'PUT',
            contentType: 'application/json',
            dataType: 'json',
            headers: ko.toJS(headers)
        });
        promise.always(function () {
            console.log('[PUT] ' + url, { url: url, data: data, headers: headers, args: arguments });
        });
        return promise;
    },

    post: function (url, data, headers) {
        var promise = $.ajax({
            url: url,
            data: this.toJSON(data),
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            headers: ko.toJS(headers)
        }).always(function () {
            console.log('[POST] ' + url, { url: url, data: data, headers: headers, args: arguments });
        });

        return promise;
    },

    remove: function (url, query, headers) {
        var promise = $.ajax({
            url: url,
            data: query,
            type: 'DELETE',
            headers: ko.toJS(headers)
        });
        promise.always(function () {
            console.log('[DELETE] ' + url, { url: url, query: query, headers: headers, args: arguments });
        });
        return promise;
    }
};